import { Controller } from "@hotwired/stimulus"

// Cuenta prestaciones vivas en la lista (ignora el <template> del nested-form).
export default class extends Controller {
  static targets = ["addButton", "count", "list"]

  static values = {
    max: { type: Number, default: 0 },
    wrapperSelector: { type: String, default: ".imagen-prestaciones-form-wrapper" }
  }

  connect() {
    this.refreshQueued = false
    const root = this.listRoot()
    this.observer = new MutationObserver(() => this.queueRefresh())
    this.observer.observe(root, { childList: true, subtree: false })
    this.refresh()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.refreshQueued = false
  }

  queueRefresh() {
    if (this.refreshQueued) return
    this.refreshQueued = true
    requestAnimationFrame(() => {
      this.refreshQueued = false
      this.refresh()
    })
  }

  refresh() {
    const count = this.currentCount()

    if (this.hasCountTarget && this.countTarget.textContent !== `${count}`) {
      this.countTarget.textContent = `${count}`
    }

    if (this.hasAddButtonTarget) {
      const reached = this.maxValue > 0 && count >= this.maxValue
      this.addButtonTarget.disabled = reached
      this.addButtonTarget.title = reached
        ? `Solo se permiten ${this.maxValue} prestaciones por orden`
        : ""
    }
  }

  listRoot() {
    return this.hasListTarget ? this.listTarget : this.element
  }

  currentCount() {
    return Array.from(this.listRoot().children)
      .filter((el) => el.matches?.(this.wrapperSelectorValue))
      .filter((wrapper) => {
        const destroyInput = wrapper.querySelector('input[name*="[_destroy]"]')
        const marked = destroyInput && (destroyInput.value === "1" || destroyInput.value === "true")
        const hidden = wrapper.hidden || wrapper.classList.contains("d-none") || wrapper.style.display === "none"
        return !marked && !hidden
      }).length
  }
}
